import React from 'react'
import touch2 from '../images/touch2.png'

import { Button } from 'reactstrap';
import './Secondsection.css';

function Secondsection() {
    return (
        <div>
        <div className="/about" id="topContainer2">
        <div className="container">
        <div className="row">
       
            <div className="col-sm-6 box" id="aboutmecontent">
         <h2 id="aboutmehead">About me</h2>
               
                <p className="content1">
            I graduated from Crescent University in Computer Science with Statistics, double major. 
                I am a user centered UX Designer passionate about leveraging real-world user insights to 
                create easy to use products geared at achieving business goals. 
            </p>
            <p className="content1"> 
            Putting people first, I research, design, and engineer interactions between humans and technology. 
            For me, it has been enlightening. I saw my simple solutions make a deep impact on the community.
             But it also highlighted the need for human-centred solutions globally.

            </p>
            <p className="content1">
            My work is motivated by a commitment to ensuring the world enjoys the benefits of innovative
             technological solutions that can serve a diverse population. I'm curious about how to develop technologies 
             that can change to meet the requirements and preferences of different users, whether to enhance
              straightforward interactions like touchscreen text entry or more difficult ones like working with
machine learning models.


            </p>
    
            <p className="content1">
            I love to solve problems, make improvements and create designs that are 
            intuitive, simple to use and deliver memorable customer experiences.
<br/>

            </p>
    
            {/* <p className="content1">
            When I'm not working or with my family, I like to watch
             movies, read novels, play scrabble, and hang out with my friends.
              I'm also a major animal lover.

    </p> */}
    
            <p className="content1">
            I am seeking like minds who share my desire to eliminate limitations to technology use.

            </p>

            <p className="content1">
            Passion about all things Fintech,Crypto and Web3.

            </p>
            
            <Button  href="./document/Akilo Pelumi RESUME 1.pdf" download="CV- Akilo Pelumi" id="DownloadCv" type="button" variant="primary" ><span>Download CV</span></Button>{' '}
            
            </div>  
            <div className="col-sm-6 box" id="imagetouch2"><img src={touch2} height="490" width="400" class="img-fluid img-thumbnail" alt="" /></div>  
        </div>
      </div>
    </div>
        </div>
    )
}

export default Secondsection
